import { SanityRootProductCategory } from '@gelato-api-ui/core/sanity/sanity-root-product-category';

export const DYNAMIC_APPAREL_SANITY_ROOT_PRODUCT_CATEGORIES = [
  SanityRootProductCategory.MENS_CLOTHING,
  SanityRootProductCategory.KIDS_BABY_CLOTHING,
  SanityRootProductCategory.WOMENS_CLOTHING,
];
export const DYNAMIC_WALLART_SANITY_ROOT_PRODUCT_CATEGORIES = [
  SanityRootProductCategory.WALL_ART,
  SanityRootProductCategory.CLEARANCE,
];
